import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=3c1d15bc&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1d15bc')) {
      api.createRecord('3c1d15bc', component.options)
    } else {
      api.reload('3c1d15bc', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=3c1d15bc&", function () {
      api.rerender('3c1d15bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UCHYKKrtV6av/JS/comp/openstreetmap.vue"
export default component.exports